import { ref as m, onMounted as h, watch as T } from "vue";
const y = {
  repeatAfterDays: 0,
  scrollPercentageToTrigger: 0,
  delaySecondsAndTrigger: 0,
  triggerOnExitIntent: !0,
  touchDeviceSensitivity: 15,
  scrollDebounceMillis: 300,
  triggerOnPageLoad: !1,
  handleScrollBars: !1,
  LSItemKey: "vue-exit-intent"
};
function w(t) {
  return {
    addMouseListener: () => {
      document.documentElement.addEventListener("mouseleave", t);
    },
    removeMouseLeaveListeners: () => {
      document.documentElement.removeEventListener("mouseleave", t);
    }
  };
}
const D = (t, e) => {
  const o = I(
    e,
    t.scrollDebounceMillis
  );
  return {
    addScrollListener: () => {
      window.addEventListener("scroll", o);
    },
    removeScrollListeners: () => {
      window.removeEventListener("scroll", o);
    }
  };
};
function E(t, e) {
  let o = 0, n = !1, r = 0;
  const s = (c) => {
    window.pageYOffset !== 0 && (n = !0, o = c.touches[0].clientY, r = Date.now());
  }, l = (c) => {
    if (!n)
      return;
    const u = c.touches[0].clientY - o;
    if (u < 0)
      return;
    const d = Date.now(), i = d - r;
    u / i * t.touchDeviceSensitivity > 100 && (n = !1, e()), r = d;
  }, a = () => {
    n = !1;
  };
  return {
    addTouchListeners: () => {
      document.addEventListener("touchstart", s), document.addEventListener("touchmove", l), document.addEventListener("touchend", a);
    },
    removeTouchDeviceListeners: () => {
      document.removeEventListener("touchstart", s), document.removeEventListener("touchmove", l), document.removeEventListener("touchend", a);
    }
  };
}
function I(t, e = 300) {
  let o;
  return function(...n) {
    clearTimeout(o), o = setTimeout(() => t.apply(this, n), e);
  };
}
function b(t) {
  const e = localStorage.getItem(t.LSItemKey);
  return e ? t.repeatAfterDays === 0 ? !1 : Date.now() - parseInt(e) > t.repeatAfterDays * 864e5 : !0;
}
function p() {
  return "ontouchstart" in window || navigator.maxTouchPoints > 0 || matchMedia("(pointer:coarse)").matches;
}
function O(t = {}) {
  const e = { ...y, ...t }, o = e.LSItemKey + "-unsubscribed", n = m(!1), r = m(!1), s = m(!1), { addMouseListener: l, removeMouseLeaveListeners: a } = w(i), { addScrollListener: f, removeScrollListeners: L } = D(
    e,
    i
  ), { addTouchListeners: c, removeTouchDeviceListeners: u } = E(
    e,
    i
  );
  function d() {
    n.value = !1, e.handleScrollBars && (document.body.style.overflowY = "auto");
  }
  function i() {
    n.value = !0, r.value = !1, localStorage.setItem(e.LSItemKey, JSON.stringify(Date.now())), e.handleScrollBars && (document.body.style.overflowY = "hidden");
  }
  function g() {
    localStorage.removeItem(e.LSItemKey), localStorage.removeItem(o), n.value = !1, r.value = !0, s.value = !1;
  }
  function S() {
    localStorage.setItem(o, (!0).toString()), s.value = !0, r.value = !1;
  }
  return h(() => {
    const v = localStorage.getItem(o);
    s.value = v ? JSON.parse(v) : !1, r.value = b(e) && !s.value;
  }), T(r, (v) => {
    v ? (e.triggerOnExitIntent && (e.touchDeviceSensitivity && p() ? c() : l()), e.delaySecondsAndTrigger && setTimeout(() => {
      i();
    }, e.delaySecondsAndTrigger * 1e3), e.triggerOnPageLoad && i(), e.scrollPercentageToTrigger && f()) : (a(), L(), u());
  }), {
    isShowing: n,
    isAllowedToGetTriggered: r,
    isUnsubscribed: s,
    close: d,
    resetState: g,
    unsubscribe: S
  };
}
export {
  O as useVueExitIntent
};
